export default "__VITE_ASSET__CqIRHSFv__"